// extracted by mini-css-extract-plugin
export default {"kpiWrapper":"qaWad__kpiWrapper","kpiData":"PE10k__kpiData"};